module.exports = __webpack_public_path__ + "img/nairobi2.239a08b7.jpg";